<template>
  <div>
  <van-popup v-model="visible" position="bottom" :style="{ height: 'auto' }" round :lock-scroll="false" @closed="onClosed">
    <div class="welfare-popup">
      <div class="welfare-popup__handle"></div>
      <p class="welfare-popup__title">{{ $t('common.welfare_popup_title') }}</p>

      <div class="welfare-popup__tasks">
        <!-- 每日签到 -->
        <div class="task-item" @click="goWelfare">
          <div class="task-icon">📅</div>
          <div class="task-info">
            <p class="task-name">{{ $t('common.welfare_sign_now') }}</p>
            <p class="task-coin">+{{ welfareConfig.sign_coin }} {{ $t('common.welfare_beans') }}</p>
          </div>
        </div>

        <!-- 阅读任务 -->
        <div class="task-item" @click="goWelfare">
          <div class="task-icon">📖</div>
          <div class="task-info">
            <p class="task-name">{{ $t('common.welfare_read_daily') }}</p>
            <p class="task-coin">+{{ welfareConfig.read_coin }} {{ $t('common.welfare_beans') }}</p>
          </div>
        </div>

        <!-- 邀请好友 -->
        <div class="task-item" @click="goInvite">
          <div class="task-icon">👥</div>
          <div class="task-info">
            <p class="task-name">{{ $t('common.welfare_go_invite') }}</p>
            <p class="task-coin">+{{ welfareConfig.invite_coin }} {{ $t('common.welfare_beans') }}</p>
          </div>
        </div>

        <!-- 观看广告 -->
        <div class="task-item" @click="watchVideo">
          <div class="task-icon">📺</div>
          <div class="task-info">
            <p class="task-name">{{ $t('common.welfare_watch_video') }}</p>
            <p class="task-coin" v-if="welfareConfig.watch_video_times > 0">
              +{{ welfareConfig.watch_video_coin }} {{ $t('common.welfare_beans') }}
              · {{ $t('common.welfare_watch_video_remain', [welfareConfig.watch_video_times]) }}
            </p>
            <p class="task-coin task-coin--disabled" v-else>{{ $t('common.welfare_watch_video_full') }}</p>
          </div>
        </div>

        <!-- 访问网站 -->
        <div class="task-item" @click="visitSite">
          <div class="task-icon">🌐</div>
          <div class="task-info">
            <p class="task-name">{{ $t('common.welfare_visit_site') }}</p>
            <p class="task-coin" v-if="visitCountdown < 0">
              +200 {{ $t('common.welfare_beans') }}
            </p>
            <p class="task-coin task-coin--timer" v-else-if="visitCountdown > 0">
              {{ $t('common.welfare_visit_site_timer', [visitCountdown]) }}
            </p>
            <p class="task-coin task-coin--timer" v-else>...</p>
          </div>
        </div>
      </div>

      <van-button type="primary" block round class="welfare-popup__btn" @click="goWelfare">
        {{ $t('common.welfare_popup_go') }}
      </van-button>
    </div>
  </van-popup>

  <!-- 访问网站奖励弹窗 -->
  <van-dialog v-model="visitRewardDialog" :title="$t('common.welfare_beans')" confirm-button-text="OK" @confirm="visitRewardDialog = false">
    <p style="text-align:center;padding:30px 0;font-size:32px;color:#FCAD0F;font-weight:bold;">+200 {{ $t('common.welfare_beans') }}</p>
  </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'WelfarePopup',
  props: {
    show: { type: Boolean, default: false },
    welfareConfig: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      visible: false,
      visitCountdown: -1,
      visitTimer: null,
      visitSiteRemaining: 0,
      visitRewardDialog: false,
    }
  },
  watch: {
    show(val) {
      this.visible = val
    },
    visible(val) {
      if (!val) this.$emit('close')
    },
    welfareConfig: {
      immediate: true,
      handler(val) {
        if (val && val.visit_site_config) {
          this.visitSiteRemaining = val.visit_site_config.remaining || 0
        }
      }
    }
  },
  created() {
    const start = localStorage.getItem('visit_site_start')
    if (start) {
      const elapsed = Date.now() - parseInt(start)
      localStorage.removeItem('visit_site_start')
      if (elapsed >= 20000) {
        this.$nextTick(() => this.claimVisitReward())
      } else {
        // 不足20s回来（如微信跳转后返回），提示重新阅读
        this.$nextTick(() => this.$toast(this.$t('common.welfare_visit_site_too_short')))
      }
    }
    document.addEventListener('visibilitychange', this._onVisibilityChange)
  },
  beforeDestroy() {
    if (this.visitTimer) clearInterval(this.visitTimer)
    document.removeEventListener('visibilitychange', this._onVisibilityChange)
  },
  methods: {
    onClosed() {
      this.$emit('close')
    },
    goWelfare() {
      this.visible = false
      this.$router.push('/welfare')
    },
    goInvite() {
      this.visible = false
      this.$router.push('/invitation')
    },
    watchVideo() {
      if (!this.welfareConfig.watch_video_times) return
      this.$axios.post('/api/ad/receive_coin')
        .then(res => {
          this.$toast('+' + this.welfareConfig.watch_video_coin + ' ' + this.$t('common.welfare_beans'))
          this.$emit('reward-claimed', res.data.data)
        })
        .catch(err => {
          this.$toast(err.response && err.response.data && err.response.data.message)
        })
    },
    visitSite() {
      if (this.visitCountdown >= 0) return
      const url = this.welfareConfig.visit_site_config && this.welfareConfig.visit_site_config.url
      if (!url) return
      // 先设置状态再打开URL，避免 visibilitychange 在 window.open 期间触发时 visitTimer 尚未赋值
      localStorage.setItem('visit_site_start', Date.now())
      this.visitCountdown = 20
      this._startCountdownTimer()
      try {
        const w = window.open(url, '_blank')
        if (!w) window.location.href = url
      } catch (e) {
        window.location.href = url
      }
    },
    _startCountdownTimer() {
      if (this.visitTimer) clearInterval(this.visitTimer)
      this.visitTimer = setInterval(() => {
        // 若已被外部重置（如提前切回），停止并退出，不覆盖 visitCountdown
        if (this.visitCountdown <= 0) {
          clearInterval(this.visitTimer)
          this.visitTimer = null
          return
        }
        this.visitCountdown--
        if (this.visitCountdown <= 0) {
          clearInterval(this.visitTimer)
          this.visitTimer = null
          this.visitCountdown = 0
        }
      }, 1000)
    },
    _onVisibilityChange() {
      if (document.hidden) return
      // 只有本组件启动了倒计时才处理，防止与其他同时挂载的组件竞争 localStorage
      if (this.visitCountdown < 0) return
      const start = localStorage.getItem('visit_site_start')
      if (!start) return
      const elapsed = Date.now() - parseInt(start)
      if (this.visitTimer) clearInterval(this.visitTimer)
      localStorage.removeItem('visit_site_start')
      if (elapsed >= 20000) {
        // 停留时长足够，自动领取
        this.claimVisitReward()
      } else {
        // 提前切回，取消并提示
        this.visitCountdown = -1
        this.$toast(this.$t('common.welfare_visit_site_too_short'))
      }
    },
    claimVisitReward() {
      this.$axios.post('/api/welfare/visit_site')
        .then(res => {
          this.visitCountdown = -1
          this.visitRewardDialog = true
          this.$emit('reward-claimed', res.data.data)
        })
        .catch(err => {
          this.$toast(err.response && err.response.data && err.response.data.message)
          this.visitCountdown = -1
        })
    },
  }
}
</script>

<style scoped>
.welfare-popup {
  padding: 20px 30px 40px;
}
.welfare-popup__handle {
  width: 60px; height: 6px;
  background: #e0e0e0; border-radius: 3px;
  margin: 0 auto 24px;
}
.welfare-popup__title {
  font-size: 32px; font-weight: bold;
  color: #303133; margin-bottom: 28px;
  text-align: center;
}
.welfare-popup__tasks {
  margin-bottom: 28px;
}
.task-item {
  display: flex; align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}
.task-icon {
  font-size: 36px; width: 60px; flex-shrink: 0;
}
.task-info { flex: 1; }
.task-name {
  font-size: 28px; color: #303133; margin-bottom: 6px;
}
.task-coin {
  font-size: 24px; color: #FCAD0F;
}
.task-coin--disabled { color: #bfc2cc; }
.task-coin--timer { color: #4D77FD; }
.welfare-popup__btn {
  background: linear-gradient(-90deg, #4D77FD, #7797FF);
  border: none; height: 80px; font-size: 30px;
}
</style>
